import React from "react";
import "./Collections.css";
import { Link } from "react-router-dom";

const collections = [
  {
    title: "Rings Collection",
    image: "https://spinellejewelry.com/cdn/shop/files/RI-23030-Rose4.jpg?v=1742284134&width=450",
  },
  {
    title: "Necklaces Collection",
    image: "https://spinellejewelry.com/cdn/shop/files/R-9272_p.jpg?v=1721811830&width=450",
  },
  {
    title: "Earrings Collection",
    image: "https://spinellejewelry.com/cdn/shop/files/BL-19PY.jpg?v=1743058160&width=450",
  },
  {
    title: "Bracelets Collection",
    image: "https://spinellejewelry.com/cdn/shop/files/B-428_F.jpg?v=1721818198&width=450",
  },
  // Add more if needed
];

const Collections = () => {
  return (
    <div className="collections-section">
      <h2 className="collections-heading">Explore Full Collections</h2>
      <div className="collections-grid">
        {collections.map((item, idx) => (
          <div className="collection-card" key={idx}>
            <img src={item.image} alt={item.title} />
            <div className="collection-title">{item.title}</div>
          </div>
        ))}
      </div>
         <div className="view-all-container">
        <button className="view-all-button"><Link to="/products" style={{textDecoration:'none', color:'white'}}>View All Collection</Link></button>
      </div>
    </div>
  );
};

export default Collections;
